import React from 'react';
import { getEstimatedDeliveryDate } from '../../utils/deliveryDateUtils';

const EstimatedDelivery = ({ tag, orderDate, isPaid }) => {
    const { min, max } = getEstimatedDeliveryDate(tag, orderDate ? new Date(orderDate) : new Date());

    const format = (date) =>
        date.toLocaleDateString('es-EC', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
        });

    return (
        <>
            <div className="mt-2 text-success">
                <strong>Entrega estimada:</strong> entre {format(min)} y {format(max)}
                {!isPaid && (
                    <span className="fw-bold text-uppercase"> si paga ahora</span>
                )}
            </div>
            <div className="alert alert-info mt-3 p-2 rounded small border-0" style={{ backgroundColor: '#fff5f2', color: '#b5430f' }}>
                🚚 Todos los paquetes son asegurados al 100% durante su envío.
            </div>
        </>
    );
};

export default EstimatedDelivery;
